import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import shortenNumber from '../utils/shortenNumber';
import WhoTooltipWrapper from './WhoTooltipWrapper';
import s from './Stat.scss';
var shorten = function (number) { return shortenNumber(number, 0, Math.floor); };
var Stat = function (_a) {
    var deviation = _a.deviation, showOnlyNumbers = _a.onlyNumbers, statNameLocaleKey = _a.statNameLocaleKey, _b = _a.statCount, statCount = _b === void 0 ? 0 : _b, userListType = _a.userListType, biData = _a.biData, dataHook = _a.dataHook, tooltipDataHook = _a.tooltipDataHook, className = _a.className, Icon = _a.icon, onClick = _a.onClick;
    var t = useTranslation().t;
    var onlyNumbers = !statNameLocaleKey || showOnlyNumbers;
    var hasTooltip = userListType && deviation;
    var iconAndStat = (React.createElement(PlainButtonOrLink, __assign({ className: s['stat-button'], onClick: onClick, biData: biData }, (onClick ? { style: { cursor: 'pointer' } } : { tabIndex: -1 })),
        Icon && (React.createElement(Icon, { className: s['stat-icon'], size: IconSize.SMALL, disableDefaultColors: true })),
        React.createElement("span", { className: s['stat-text'] },
            React.createElement("span", { className: s['stat-count'] }, shorten(statCount)),
            ' ',
            React.createElement("span", { className: s['stat-name'] }, statCount === 1
                ? t(statNameLocaleKey)
                : t(statNameLocaleKey + "_plural")))));
    return (React.createElement("span", { className: classnames(s['stat'], hasTooltip && s['has-tooltip'], onlyNumbers && s['only-numbers'], className) }, userListType && deviation ? (
    // TODO: there should be a way to open these with the keyboard
    React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: userListType, dataHook: dataHook, tooltipDataHook: tooltipDataHook }, iconAndStat)) : (iconAndStat)));
};
Stat.displayName = 'Stat';
export default Stat;
//# sourceMappingURL=Stat.js.map